export const getLabelsTypeNode = (type: string) => {
  if (!type) {
    return null
  }
  switch (type) {
    case 'PORT':
      return $t('labels.nodeModule.port')
    case 'DEPOT':
      return $t('labels.nodeModule.depot')
    case 'ICD':
      return $t('labels.nodeModule.icd')
    case 'WAREHOUSE':
      return $t('labels.nodeModule.warehouse')
    case 'BORDER_GATE':
      return $t('labels.nodeModule.borderGate')
    case 'TOLL_STATION':
      return $t('labels.nodeModule.tollStation')
    default:
      return null
  }
}

export const warehouseTypes = ['BONDED', 'NORMAL']

export const getLabelsWarehouseType = (type: string) => {
  if (!type) {
    return null
  }
  switch (type) {
    case 'BONDED':
      return $t('labels.nodeModule.bonded')
    case 'NORMAL':
      return $t('labels.nodeModule.normal')
    default:
      return null
  }
}

export const getLabelTransportType = (type: string) => {
  if (!type) {
    return null
  }
  switch (type) {
    case 'IMPORT':
      return $t('labels.nodeModule.import')
    case 'EXPORT':
      return $t('labels.nodeModule.export')
    case 'DOMESTIC':
      return $t('labels.nodeModule.domestic')
    default:
      return null
  }
}
